import React from 'react';
import { prop } from 'ramda';
import { componentService } from 'js/services/component.service';
import { useDeviceSelector } from 'js/store/hooks';

import { Menu as MenuCore } from 'js/components/main/Menu/Menu';
import { BottomNavigation } from './components/BottomNavigation';

export const Menu = () => {
    const isDesktop = useDeviceSelector(prop('isDesktop'));

    if (isDesktop) {
        return <MenuCore />;
    }

    return <BottomNavigation />;
};

componentService.registerWebContentComponents({ Menu });
